/**
 * Active workspace company for billing, Local Bridge, chat, etc.
 * Header `selectedCompany` wins so multi-company operators can switch context;
 * profile `user.companyId` is fallback when nothing is selected.
 */
export function resolveWorkspaceCompanyId(
  userCompanyId: string | undefined,
  selectedCompanyId: string | undefined,
  availableCompanies: Array<{ company: { id: string } }>
): string | undefined {
  if (selectedCompanyId) return selectedCompanyId;
  if (availableCompanies.length === 1) return availableCompanies[0].company.id;
  if (userCompanyId) return userCompanyId;
  return undefined;
}

/**
 * Render surface / Control Bridge: header `selectedCompany` drives kryspace slug
 * (KRYBOT browser-flow spec §3). Profile `user.companyId` is fallback only when
 * the user has a single membership (or no instance list yet).
 */
export function resolveRenderSurfaceCompanyId(
  userCompanyId: string | undefined,
  selectedCompanyId: string | undefined,
  availableCompanies: Array<{ company: { id: string } }>
): string | undefined {
  if (selectedCompanyId) return selectedCompanyId;
  if (availableCompanies.length === 1) return availableCompanies[0].company.id;
  if (availableCompanies.length === 0 && userCompanyId) return userCompanyId;
  return undefined;
}
